
export enum RentRuleMatchBehaviour {
    PROPOSE_MATCHES_LEGACY_STYLE = 0,               // Deprecated, move away from this ideally
    AUTO_YOUNGEST_FIRST = 1,                        // Will match 'this month' first (so anything 1 week ago that is due and 1 week ahead). Then if nothing it will much by DueDate DESC for overdue items if any, and then by DueDate ASC for not-yet due items
    AUTO_OLDEST_FIRST = 2,                          // WIll match oldest debt first even if there is something more suitable
    IGNORE_TRANSACTION = -1,                         // To pre-emptively mark something as to be ignored
    MARK_AS_NOT_RENT_BOOK_RELATED = -2,              // To move it away from rent telling the system you've guessed wrong and this isn't rent book related (probably should be matched to financial items etc...)
}

export const RentRuleMatchBehaviourReverse = {
    "0": "Propose match",
    "1": "Youngest first",
    "2": "Oldest first",
    "-1": "Ignore",
    "-2": "Not rent",
}

export const RentRuleMatchBehaviourRadioButtonLabel = {
    0: 'Propose match',
    1: 'Match closest',
    2: 'Match oldest',
}

export const RentRuleMatchBehaviourRadioButtonDescription = {
    0: 'Bring up for review',
    1: 'Reconcile automatically',
    2: 'Reconcile automatically',
}

export const RentRuleMatchBehaviourReverseAction = {
    0: 'Propose a match',
    1: 'Match automatically to the closest charge',
    2: 'Match automatically to the oldest charge',
    '-1': 'Ignore the transaction',
}

